import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IActiveServiceEvent, IGetServiceEventState } from '../../actions/types/services/GetAllServiceEventTypes';

/**
 * Initial Serivce Event state in store
 */
const initialState: IGetServiceEventState = {
  isLoading: false,
  serviceEventErrorMessage: '',
  activeServiceEvent: []
};

const fetchIngressServiceEventSlice = createSlice({
  name: 'fetchServiceEvent',
  initialState,
  reducers: {
    fetchIngressServiceEventStarted: (state) => {
      state.isLoading = true;
    },

    fetchIngressServiceEventSuccess: (state, action: PayloadAction<IActiveServiceEvent[]>) => {
      state.isLoading = false;
      state.activeServiceEvent = action.payload;
      state.serviceEventErrorMessage = '';
    },

    fetchIngressServiceEventFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.activeServiceEvent = initialState.activeServiceEvent;
      state.serviceEventErrorMessage = action.payload;
    },

    clearIngressServiceEventDetails: (state) => {
      state.isLoading = false;
      state.activeServiceEvent = initialState.activeServiceEvent;
      state.serviceEventErrorMessage = '';
    }
  }
});
export const {
  fetchIngressServiceEventStarted,
  fetchIngressServiceEventSuccess,
  fetchIngressServiceEventFail,
  clearIngressServiceEventDetails
} = fetchIngressServiceEventSlice.actions;
export default fetchIngressServiceEventSlice.reducer;
